import { createReducer } from 'lib/createReducer';
import {
    SEARCH_PARAMS_SUCCESS
} from '../constants/SearchParams';

const initialState = {
    spCount: 0
};

export default createReducer(initialState, {
    [SEARCH_PARAMS_SUCCESS]: (state, data) => {

        return Object.assign({
            spCount: state.spCount+1
        }, data.payload);
    }
});